import { MAIN_IMAGE_ROOT } from 'app_config';
import type { HeaderInitials } from 'common/models';
import ImageComponent from 'components/ImageComponent/ImageComponent';
import { useCustomTranslation } from 'helpers/translationHelper';
import React from 'react';

import AddressBlock from './AddressBlock';

interface OwnProps {
  company: HeaderInitials;
  withTitle?: boolean;
  customTitle?: string;
  hideLogo?: boolean;
}

const CompanyBlock = (props: OwnProps) => {
  const { company, withTitle, customTitle, hideLogo } = props;
  const { t } = useCustomTranslation();

  return (
    <div className="Company">
      <div className={`info ${hideLogo || !company.logoUrl ? '' : 'showLogo'}`}>
        {withTitle && (
          <div className="BlockHeader">{customTitle || t('customData.companyHeader')}</div>
        )}
        <div className="Name">{company.name}</div>
        {company.address && <AddressBlock address={company.address} />}
        {company.identificationNumber && (
          <div>
            {t('customData.company.identificationNumber', {
              number: company.identificationNumber
            })}
          </div>
        )}
        {company.taxNumber && (
          <div>{t('customData.company.taxNumber', { number: company.taxNumber })}</div>
        )}
      </div>
      {!hideLogo && (
        <div className="logo">
          {company.logoUrl && <ImageComponent url={`${MAIN_IMAGE_ROOT}${company.logoUrl}`} />}
        </div>
      )}
    </div>
  );
};

export default CompanyBlock;
